export default __webpack_public_path__ + "static/media/hosttoolsLogo.32a0c7f8.svg";